import { pixiesetAssetBaseURIs } from "./pixieset-urls"

export enum ImageFormat {
	JPG = "jpg",
	PNG = "png",
	WEBP = "webp",
	AVIF = "avif",
}

export function processImageUrl(options: {
	url: string
	shortestSidePxSizeOfResize?: number
	format?: ImageFormat
	quality?: number
}): string {
	try {
		const url = new URL(options.url)
		const peImagesHost = new URL(pixiesetAssetBaseURIs.imagesPe).host
		if (
			url.host !== "images.polarr.co" &&
			url.host !== "images.polarr.com" &&
			url.host !== peImagesHost
		) {
			return options.url
		}
		if (options.quality) {
			if (options.quality < 0) {
				options.quality = 0
			} else if (options.quality > 100) {
				options.quality = 100
			}
			url.pathname = `quality/${options.quality}` + url.pathname
		}
		if (options.shortestSidePxSizeOfResize) {
			url.pathname = `resized/${options.shortestSidePxSizeOfResize}px` + url.pathname
		}
		if (options.format) {
			url.pathname = `${url.pathname}.${options.format}`
		}
		return url.toString()
	} catch (error) {
		return options.url
	}
}
